<script setup>
	import { ref, watch } from 'vue'

	const props = defineProps(['dump'])

	const minimized = ref(true)

	const toggle = () => {
		minimized.value = ! minimized.value
	}
</script>

<template>
		<div v-if="dump" :class="{ 'minimized': minimized }" class="card test-dump bg-dark">

			<div @click="toggle()" class="card-header">
				<div class="card-title">Test Dump</div>

				<div v-if="minimized" class="icon"><FontAwesomeIcon icon="fas fa-plus" /></div>
				<div v-else class="icon"><FontAwesomeIcon icon="fas fa-minus" /></div>
			</div>
			<div v-if="! minimized" class="card-body">
				<pre>{{ dump }}</pre>
			</div>
		</div>
</template>

<style lang="scss" scoped>
	.test-dump {
		width: 100%;
		max-width: 50%;
		max-height: 80%;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999;
		opacity: 0.95;
    background-color: #222 !important;
		color: #fff;
		box-shadow: 0px -4px 26px 9px rgba(0,0,0,0.2);
		overflow-y: auto;

		&.minimized {
			padding: 0;
		}

		.card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px 10px 0;
			cursor: pointer;
			background-color: var(--bs-primary) !important;
			color: #222;

			.card-title {
				margin-bottom: 0;
				font-size: 16px;
			}
		}

		pre {
			white-space: pre-wrap;
			font-size: 14px;
		}

		.icon {
			right: 8px;
			font-size: 24px;
		}

		.item {
			border-bottom: 1px dashed #bfbfbf;
			padding-top: 2px;
			padding-bottom: 2px;
			padding-left: 15px;

			&:first-of-type {
				padding-top: 10px;
			}

			&:last-of-type {
				padding-bottom: 10px;
			}
		}

		span {
			background-color: #ddd;
			padding: 1px 3px;
		}
	}
</style>